export default "__VITE_ASSET__D8b98cjl__"